
<div class="w-full flex justify-start items-center p-4">
  <i class="ico-Close cursor-pointer text-xl ml-3"
    (click)="dialogRef.close()"></i>
  <h3 class="text-lg font-bold">هتل مورد نظر شما دیگر فعالیت ندارد.</h3>
</div>
<div class="w-full px-5">
  <p class="text-black-500">برای مشاهده هتل های مشابه کلیک کنید.</p>
</div>
<div class="w-full p-5 flex justify-start">
  <button [routerLink]="data.BreadCrumb[1].Url"
   [queryParams]="{search_box:  data.BreadCrumb[1].Url.Name, date:data.SearchSection.StartDate,endDate:data.SearchSection.EndDate}" 
   routerLinkActive="router-link-active"   mat-flat-button color="primary" class="!h-11 w-[140px] !text-base font-semi-bold ml-2">
    هتل های مشابه
</button>
<button (click)="dialogRef.close()"  class="!h-11 !bg-gray-200  w-[140px]" mat-button color="disabled">
    بستن
</button>
</div>